"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authentication = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var AuthenticationContext_1 = require("./AuthenticationContext");
var SessionUtils_1 = require("./SessionUtils");
var react_router_dom_1 = require("react-router-dom");
var container_1 = require("../../ioc/container");
var ApiAdapter_1 = require("../../adapters/ApiAdapter");
var useAuthentication = function (scope, fetchIdentity) {
    if (!scope) {
        scope = 'default';
    }
    var storageKey = 'User-' + scope;
    var history = react_router_dom_1.useHistory();
    var _a = react_2.useState(), identity = _a[0], setIdentity = _a[1];
    var _b = react_2.useState(function () {
        var storedToken = sessionStorage.getItem(storageKey);
        if (storedToken) {
            // Update the ApiAdapter to use this token
            container_1.getCoreContainer().get(ApiAdapter_1.ApiAdapter).setAuthenticationToken(storedToken);
            return SessionUtils_1.getUserFromSession(storageKey);
        }
        else {
            return undefined;
        }
    }), user = _b[0], setUser = _b[1];
    // Track whether we are currently fetching the user's identity. If we have a user then this
    // defaults to being 'true' if we have a fetchIdentity method to avoid the interim state being
    // possible of having a user but not having yet started to fetch the identity (may appear)
    // to the application that the user does not have an identity for a brief moment before
    // fetching kicks in on a subsequent re-render.
    var _c = react_2.useState(user && !!fetchIdentity), fetchingIdentity = _c[0], setFetchingIdentity = _c[1];
    // Whether we are logged in is computed simply from if we have a user or not.
    var isLoggedIn = !!user;
    react_2.useEffect(function () {
        if (user) {
            // Do we have an identity source? If so, go and try to retrieve the
            // identity.
            if (fetchIdentity) {
                setFetchingIdentity(true);
                fetchIdentity(user).then(function (identity) {
                    setIdentity(identity);
                    setFetchingIdentity(false);
                });
            }
        }
    }, [user]);
    react_2.useEffect(function () {
        if (!window.location.hash) {
            // We test for a hash as many oAuth flows will bring us back to the root URL /
            // with a hash on the end containing the token. We don't want to reset the onwards
            // URL as the login method will be called later and we will have lost track of the
            // real onwards destination.
            SessionUtils_1.setOnwardsPath(storageKey, window.location.pathname);
        }
    }, [window.location.pathname]);
    return {
        user: user,
        identity: identity,
        permissions: user ? user.permissions : [],
        fetchingIdentity: fetchingIdentity,
        isLoggedIn: isLoggedIn,
        login: function (token) { return __awaiter(void 0, void 0, void 0, function () {
            var user, onwardsPath;
            return __generator(this, function (_a) {
                user = SessionUtils_1.extractUserFromToken(token);
                setUser(user);
                // Store the user in session storage
                SessionUtils_1.storeUserTokenInSession(token, storageKey);
                onwardsPath = SessionUtils_1.getOnwardsPath(storageKey);
                if (onwardsPath) {
                    history.push(onwardsPath);
                }
                return [2 /*return*/];
            });
        }); },
        logout: function () {
            SessionUtils_1.clearUserTokenFromSession(storageKey);
            setUser(undefined);
        },
    };
};
var Authentication = function (props) {
    var auth = useAuthentication(props.scope, props.fetchIdentity);
    var showLogin = props.renderLogin !== undefined || props.loginComponent !== undefined;
    return (react_1.default.createElement(AuthenticationContext_1.AuthenticationContext.Provider, { value: auth },
        !auth.isLoggedIn && showLogin && (props.renderLogin ? props.renderLogin() : react_1.default.createElement(props.loginComponent, null)),
        (auth.isLoggedIn || !showLogin) && props.children));
};
exports.Authentication = Authentication;
//# sourceMappingURL=Authentication.js.map